module.exports = __webpack_public_path__ + "assets/img/chat-top-bg.05c5834a.png";